/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = ArticleWithText
 */
export enum EventOfferTemplateContentType {
  ArticleWithText = 0,
}
